// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// © Copyright Utrecht University (Department of Information and Computing Sciences)

import React, { useState, useEffect, useContext } from 'react';
import './Header.css';
import logo from '../../images/logo.svg';
import { Link } from 'react-router-dom';
import config from '../../config/config'
import NavigationContext from '../../shared/contexts/NavigationContext'

function Header() {
  const shortTitle = "EMRD"; // Hardcoded short title for responsive design
  const navigationContext = useContext(NavigationContext);
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'));

  useEffect(() => {
    // Store the selected theme in localStorage
    localStorage.setItem('theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <>
    <header className="med-main-header">
      <div className="header-left-section">
        {/* Mobile Navigation Toggle Button */}
        <button 
          className="nav-toggle-button"
          onClick={() => navigationContext?.setMobileCollapsed && navigationContext.setMobileCollapsed(!navigationContext?.mobileCollapsed)}
          aria-label="Toggle navigation"
          title={navigationContext?.mobileCollapsed ? 'Show navigation' : 'Hide navigation'}
        >
          <i className={navigationContext?.mobileCollapsed ? 'bx bx-chevron-down' : 'bx bx-chevron-up'}></i>
        </button>

        <Link to="/">
          <div>
            <img
              src={logo}
              alt="Logo"
              id="header__logo"
            />
          </div>
        </Link>
      </div>
      <h1>
        <span className="header__title-full">{config.header.title}</span>
        <span className="header__title-short">{shortTitle}</span>
      </h1>

      {/* Wrapper to place both buttons together */}
      <div className="header-buttons">
        {/* Animated Theme Toggle Button */}
        <button className={`theme-toggle ${theme}`} onClick={toggleTheme} aria-label="Toggle theme">
          <div className="icon-wrapper">
            {theme === 'light' ? '🌙' : '☀️'}
          </div>
        </button>

        {/* Email Button */}
        <div className="med-header-email-button">
          <a
            // Replace the href with a 'mailto:' link
            href={`mailto:${config.header.emailAddress}?subject=${config.header.emailSubject}`}
            target="_blank" // You might want to remove target="_blank" for mailto links, but I'll keep it for consistency
            rel="noreferrer"
          >
            <span className="email-button-text">Contact</span>
            <svg
              width="40px"
              height="40px"
              viewBox="0 0 24 24"
              id="email_button_outline"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>{config.header.emailTooltip}</title>
              {/* Modern Outlined Envelope */}
              <path
                d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                fill="none"
                stroke="var(--ui)"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <polyline
                points="22,6 12,13 2,6"
                fill="none"
                stroke="var(--ui)"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
        </div>
        {/* The GitHub button remains commented out */}
      </div>
    </header>
    {config.features.demoFeedbackBanner && (
      <div className="demo-feedback-banner" role="region" aria-label="Demo feedback">
        <span>Thank you for trying the EMRD demo! We want to hear from you. Please</span>
        <a href={`mailto:${config.header.emailAddress}?subject=Feedback%20on%20EMRD%20demo`}>
        share your feedback
        </a>
      </div>
    )}
    </>
  );
}

export default Header;